import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { FormattingRule } from '../../model';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { CdkDragHandle } from '@angular/cdk/drag-drop';
import { TranslateModule } from '@ngx-translate/core';
import { MatButtonModule } from '@angular/material/button';

@Component({
    selector: 'ft-formatting-style-line',
    templateUrl: './formatting-style-line.component.html',
    styleUrls: ['./formatting-style-line.component.scss'],
    imports: [CommonModule, MatIconModule, CdkDragHandle, TranslateModule, MatButtonModule],
})
export class FormattingStyleLineComponent implements OnChanges {
    // TODO: Skipped for migration because:
    //  Your application code writes to the input. This prevents migration.
    @Input() formattingRule: FormattingRule;
    previewStyle: any;
    @Output() deleteEvent = new EventEmitter<boolean>();

    ngOnChanges(changes: SimpleChanges): void {
        this.formattingRule = changes['formattingRule'].currentValue;
        const style = this.formattingRule.formattingStyle;
        this.previewStyle = {
            color: style.color,
            backgroundColor: style.backgroundColor,
            fontWeight: style.bold ? 'bold' : 400,
            textDecoration: (style.underlined ? 'underline ' : '') + (style.strikethrough ? 'line-through ' : ''),
            fontStyle: style.italic ? 'italic' : 'normal',
        };
    }
}
